import { useTranslation } from 'react-i18next';

import type { TenderStatus } from '../../../entities/Tender';
import { Badge } from '../Badge/Badge';

interface TenderStatusBadgeProps {
  status?: TenderStatus;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

export default function TenderStatusBadge({ status }: TenderStatusBadgeProps) {
  const { t } = useTranslation('domain');
  if (!status) {
    return null;
  }

  if (status === 'OPEN') {
    return <Badge content={t('tender.status.open')} color="teal" />;
  }

  if (status === 'CLOSED') {
    return <Badge content={t('tender.status.closed')} color="red" />;
  }

  throw new Error(`Unknown status: ${status}`);
}
